module.exports = __webpack_public_path__ + "img/logo_litecoin.d06b32e4.png";